module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-02.43c1612e.png";